// src/components/BackToTopButton.js
import React from 'react';
import { useConfig } from '../context/ConfigContext';

const BackToTopButton = () => {
  const { config } = useConfig();
  
  // Default color if config is not loaded yet
  const primaryColor = config?.colors?.primary || '#3B82F6';
  
  return (
    <button 
      onClick={() => window.scrollTo({top: 0, behavior: 'smooth'})}
      className="fixed bottom-6 right-6 p-3 text-white rounded-full shadow-lg hover:opacity-90 transition-colors focus:outline-none"
      aria-label="Back to top"
      style={{ backgroundColor: primaryColor }}
    >
      <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 10l7-7m0 0l7 7m-7-7v18" />
      </svg>
    </button>
  );
};

export default BackToTopButton;